import { Routes, Route } from 'react-router-dom';

const Contracts = props => (
    <Routes>
        <Route path="/" element={<h1>Contracts Overview</h1>} />
    </Routes>
)


export default Contracts;